// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const desguacesFullfilledReducer = makeSetReducer(['desguaces/fullfilled']);